@if (component.data$ | async; as data) {
  <p
    [innerHTML]="data.content | safeHtml"
    class="app-uig-paragraph__content {{data.styleClasses}}">
  </p>
}
